// extracted by mini-css-extract-plugin
export default {"head":"header_head__fKZws","date":"header_date__H-0d0","text":"header_text__z4DyT","iconButton":"header_iconButton__mg1pM"};